export default "dist/images/components-image-shape-control-square.d8d54ee.png";